import { create } from "zustand";
import type { Contact } from "@/models/contact";

type SessionState = {
    dealId: string;
    backendDealId: number | null;
    email: string;
    discountCode: string;
    contact: Contact | null;
    isLoadingContact: boolean;
};

type SessionActions = {
    init: (params: {
        dealId: string;
        email: string;
        discountCode: string;
    }) => void;
    setBackendDealId: (id: number) => void;
    setDiscountCode: (discountCode: string) => void;
    setContact: (contact: Contact) => void;
    setLoadingContact: (loading: boolean) => void;
};

export const useSessionStore = create<SessionState & SessionActions>()(
    (set) => ({
        dealId: "",
        backendDealId: null,
        email: "",
        discountCode: "",
        contact: null,
        isLoadingContact: false,
        init: (params) => set((s) => ({ ...s, ...params })),
        setBackendDealId: (id) => set({ backendDealId: id }),
        setDiscountCode: (discountCode) => set({ discountCode }),
        setContact: (contact) => set({ contact }),
        setLoadingContact: (loading) => set({ isLoadingContact: loading }),
    }),
);
